import { useState } from "react";
import Login from "./components/Pages/Login/Login";
import Dashboard from "./components/Pages/Dashboard/Dashboard";
import Dashboard_2 from "./components/Pages/Dashboard/Dashboard_2";
import AlarmsPage from "./components/Pages/Alarms/Alarms_menu";
import ManageSite from "./components/Master/Manage_Site";
import ManageDevice from "./components/Master/Manage_Device";
import ManageParameter from "./components/Master/Manage_Parameter";
import ManageSupervisor from "./components/Master/Manage_Supervisor";
import ManageEngineer from "./components/Master/Manage_Engineer";
import Overview from "./components/Master/Overview";
import ManageSupervisorSites from "./components/Master/ManageSupervisorSite";
import ManageSupervisorEngineers from "./components/Master/ManageSupervisorEngineers";
import EngineerSites from "./components/Master/EngineerSites";
import ManageDeviceSubscription from "./components/Master/Manage_Device_Subscription";
import ManageCustomer from  "./components/Master/ManageCustomer";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Login from "";
// import Dashboard from "/components/Dashboard";
// import ProtectedRoute from "./routes/ProtectedRoute";
import Layout from "./components/layouts/mainLayout/Layout";
import "leaflet/dist/leaflet.css";
import "./App.css";
import Alarms from "./components/Pages/Alarms/Alarms_notification";
import { Toaster } from "react-hot-toast";
import Profile from "./components/layouts/mainLayout/Profile";
import ManageAdmin from "./components/Master/Manage_Admins";
import Reports from "./components/Pages/Reports/Reports";
import Trends from "./components/Pages/Dashboard/Trends";

import SessionManager from "./components/SessionManager"; 

function App() {
  return (
    <BrowserRouter>
     <SessionManager />
    
      <Routes>

        {/* Login Page (No Sidebar) */}
        <Route path="/" element={<Login />} />

        {/* Protected Routes With Sidebar Layout */}
        <Route
          element={
            // <ProtectedRoute>
              <Layout />
            // </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/Dashboard_2/:siteId" element={<Dashboard_2 />} />
          <Route path="/alarms" element={<AlarmsPage />} />
          <Route path="/alarms-notification" element={<Alarms />} />
          <Route path="/sites" element={<ManageSite />} />
          <Route path="/devices" element={<ManageDevice />} />
          <Route path="/parameters" element={<ManageParameter />} />
          <Route path="/supervisors" element={<ManageSupervisor />} />
          <Route path="/engineers" element={<ManageEngineer />} />
          <Route path="/overview" element={<Overview />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/supervisors/site" element={<ManageSupervisorSites />} />
         
          <Route path="/engineers/site" element={<ManageSupervisorEngineers />} />
          <Route path="/engineers/engineer" element={<EngineerSites />} />
          <Route path="/manage_devices_subscription" element={<ManageDeviceSubscription />} />
          <Route path="/manage_admin" element={<ManageAdmin />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/manage_customer" element={<ManageCustomer />} />
          <Route path="/Trends" element={<Trends />} />
        </Route>

      </Routes>
      <Toaster position="top-right" />
    </BrowserRouter>
  );
}

export default App;
